module.exports = __webpack_public_path__ + "img/registration_woman.900cc7dd.png";